export default {
    container: {
        position: 'relative',
        marginLeft: '-10px',
        marginRight: '-10px'
    },
    header: {
        color: '#96979a',
        textTransform: 'uppercase',
        fontSize: '17px',
        fontFamily: 'AvenirNext-DemiBold',
        marginBottom: '10px',
        paddingLeft: '15px',
        paddingRight: '15px'
    },
    subheader: {
        color: '#96979a',
        fontFamily: 'AvenirNext',
        textTransform: 'uppercase',
        fontSize: '12px',
        fontWeight: '400',
        marginTop: '15px',
        marginBottom: '15px',
        paddingLeft: '15px',
        paddingRight: '15px'
    },
    row: {
        marginTop: '30px'
    },
    section: {
        float: 'left',
        width: '50%',
        padding: '20px',
        boxSizing: 'border-box'
    },
    formField: {
        position: 'relative',
        paddingLeft: '15px',
        paddingRight: '15px'
    },
    input: {
        width: '100%',
        height: '45px',
        padding: '3px 16px',
        fontSize: '18px',
        borderRadius: '3px',
        border: 'solid 1px #ececec',
        marginTop: '15px',
        marginBottom: '15px',
        color: '#000',
        fontFamily: 'AvenirNext',
        boxSizing: 'border-box'
    },
    textarea: {
        padding: '6px 16px',
        fontSize: '16px',
        borderRadius: '3px',
        border: 'solid 1px #ececec',
        marginTop: '15px',
        marginBottom: '15px',
        height: '120px',
        color: '#000',
        fontFamily: 'AvenirNext',
        resize: 'vertical'
    },
    checkboxContainer: {
        position: 'relative',
        display: 'inline-block',
        marginLeft: '15px',
        marginRight: '15px',
        paddingBottom: '10px'
    },
    checkbox: {
        width: '14px',
        height: '14px',
        marginRight: '10px'
    },
    checkboxLabel: {
      fontFamily: 'AvenirNext',
      fontSize: '16px',
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: '1.5',
      letterSpacing: 'normal',
      color: '#373a3c'
    },
    error: {
        borderColor: 'red'
    },
    textError: {
        fontSize: '11px',
        color: 'red',
        position: 'absolute',
        left: '15px',
        bottom: '-5px'
    }
}
